import React from "react";
import PropTypes from "prop-types";

import ConfirmContent from "@/react-components/Confirm/Content";

class ConfirmMain extends React.Component {
  render() {
    const { content, className, onRead } = this.props;

    return (
      <div className={`confirm-main-container ${className || ""}`}>
        <div className="confirm-main-container-line" />
        <ConfirmContent
          className="confirm-main-container-content"
          content={content}
          onRead={() => {
            onRead && onRead();
          }}
        />
        <div className="confirm-main-container-line" />
      </div>
    );
  }
}

ConfirmMain.propTypes = {
  content: PropTypes.string,
  onRead: PropTypes.func,
};

export default ConfirmMain;
